import { type PropsWithChildren, useState } from 'react';
import type {} from 'react/jsx-runtime';
import { SettingsMenu } from './SettingsMenu';

const SIDE_MENU_DEFAULT_WIDTH = 240;

export const SettingsPageLayout = ({ children }: PropsWithChildren) => {
  const [sideMenuWidth, setSideMenuWidth] = useState(SIDE_MENU_DEFAULT_WIDTH);

  return (
    <div
      className="grid h-full"
      style={{
        gridTemplateColumns: `${sideMenuWidth}px minmax(0, 1fr)`,
      }}
    >
      <SettingsMenu width={sideMenuWidth} setWidth={setSideMenuWidth} />
      <div className="min-h-0 overflow-y-auto bg-default">{children}</div>
    </div>
  );
};
